module.exports = __webpack_public_path__ + "img/20190727141758339.05d55905.png";